import { queryOptions } from '@tanstack/react-query'
import type { NumberPoolResponse } from '@/types/numberPoolTypes'

// Twilio number pool health — super-admin only. Refetched on open and after an
// archive, so a freed number shows up immediately rather than on the next poll.
export const numberPoolQueryOptions = () =>
  queryOptions({
    queryKey: ['numberPool'],
    queryFn: async (): Promise<NumberPoolResponse> => {
      const response = await fetch('/api/admin/numberPool')
      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.error || 'Failed to fetch the number pool')
      }
      return response.json()
    },
    staleTime: 15_000,
  })
